import palette from './palette';
import { ITypography } from './types';

const globalTypography = {
  mainFont: '"Open Sans", sans-serif',
  secondaryFont: '"Open Sans", sans-serif',
};

const typography: ITypography = {
  mainFont: globalTypography.mainFont,
  secondaryFont: globalTypography.secondaryFont,
  fontFamily: globalTypography.secondaryFont,
  fontSize: 18,
  htmlFontSize: 18,
  h1: {
    fontFamily: globalTypography.mainFont,
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: '28px',
    letterSpacing: '-0.24px',
    lineHeight: '40px',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '22px',
    letterSpacing: '-0.24px',
    lineHeight: '32px',
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '18px',
    letterSpacing: '-0.06px',
    lineHeight: '28px',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '16px',
    letterSpacing: '-0.06px',
    lineHeight: '24px',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px',
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
  },
  body1: {
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
  },
  p: {
    border: '1px solid red',
  },
  body2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.04px',
    lineHeight: '18px',
  },
  button: {
    color: palette.text.primary,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '11px',
    letterSpacing: '0.33px',
    lineHeight: '13px',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
  },
};

export default typography;
